"use client";

import { LinkBlok as Link } from "@/components/bloks/atoms/LinkBlok";
import styles from "@/components/bloks/layout/ArticleCategory/index.module.css";
import { LinkStoryblok } from "@/generated/sb/sb-types";
import { usePathname } from "@/i18n/routing";
import clsx from "clsx";

type ArticleCategoryTabsProps = {
  tabs: LinkStoryblok[];
  locale: string;
};

const ArticleCategoryTabs = ({ tabs, locale }: ArticleCategoryTabsProps) => {
  const pathname = usePathname();
  return (
    <nav className={styles.tabs}>
      {tabs?.map(tab => (
        <Link
          className={clsx(
            isTabActive(pathname, tab, locale) && styles.activeTab,
          )}
          key={tab._uid}
          blok={tab}
        />
      ))}
    </nav>
  );
};

export default ArticleCategoryTabs;

const isTabActive = (pathname: string, tab: LinkStoryblok, locale: string) => {
  return `${locale}${pathname}/` === tab.link.cached_url;
};
